export default __webpack_public_path__ + "static/epilogue-6e59a3b44661304952ed97b5ffd4314c.svg";